import { SxProps } from '@mui/joy/styles/types';
import { CSSProperties, SyntheticEvent } from 'react';
import {
  Control,
  FieldError,
  FieldValues,
  UseFormGetValues,
  UseFormSetValue,
} from 'react-hook-form';
import { NumericFormatProps } from 'react-number-format';

import { Color, Size, Variant } from 'theme/enums';

import NumberInputView from './NumberInputView';
import NumberInputWithControllerView from './NumberInputWithControllerView';

interface IExtraFormFieldProps {
  setValue?: UseFormSetValue<FieldValues>;
  getValues?: UseFormGetValues<FieldValues>;
}

export interface ISlotProps {
  input: NumericFormatProps;
}

export interface IProps
  extends Omit<NumericFormatProps, 'size' | 'error' | 'onChange'>,
    IExtraFormFieldProps {
  control?: Control<FieldValues, object>;
  error?: FieldError;
  label?: string | string[];
  tooltip?: string;
  required?: boolean;
  name: string;
  placeholder?: string;
  helperTexts?: string[];
  helperTextStyle?: CSSProperties;
  color?: Color;
  variant?: Variant;
  size?: Size;
  onChange?: (event: {
    target: { name: string; value: string };
    source: 'prop' | 'event';
    event?: SyntheticEvent;
  }) => void;
  onBlur?: (event) => void;
  onKeyDown?: (event) => void;
  slotProps?: ISlotProps;
  wrapperStyle?: CSSProperties;
  maxWidth?: string;
  sx?: SxProps;
}

const NumberInput = (props: IProps) => {
  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  const { setValue, getValues, ...other } = props;

  if (props?.control) {
    return <NumberInputWithControllerView {...other} />;
  }

  return <NumberInputView {...other} />;
};

export default NumberInput;
